import React from 'react';
import './System.css';
import { FiSmartphone } from 'react-icons/fi';
import { BsTerminalFill } from 'react-icons/bs';
import { FaCreditCard, FaReceipt, FaLandmark, FaCloud } from 'react-icons/fa';

const SystemFeatures = () => {
  const featuresData = [
    { icon: FiSmartphone, title: 'Driver app', description: 'The driver app gives you direct control of your payment system from your driving seat.' },
    { icon: BsTerminalFill, title: 'Passenger terminal', description: 'Smart and easy-to-use passenger terminal is fixed in the back of the cab, out of your field of vision.' },
    { icon: FaCreditCard, title: 'Pay by card', description: 'Accept Apple Pay, Google Pay, and all major credit cards including Visa, Mastercard and American Express.' },
    { icon: FaReceipt, title: 'Receipt printer', description: 'Print hard copy receipts for your passengers if required, and for your own records if you prefer.' },
    { icon: FaLandmark, title: "Direct payments to driver's account", description: 'We can process payments directly into driver bank account.' },
    { icon: FaCloud, title: 'Accounts Portal', description: 'Access all your eFleet account and transaction details in real-time from your driver app.' },
  ];

  return (
    <section className="features-section">
      <h2 className="main-title">Some of our key features</h2>
      <p className="subtitle">We offer comprehensive features for all your payment needs</p>
      <div className="features-grid">
        {featuresData.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="feature-card">
              <IconComponent className="feature-icon" />
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SystemFeatures;
